import Markdown from '@components/Markdown'
import { Box, Form, Text } from '@domain-group/suit-theme'

import { stringHasContent } from '@functions/utility'

import type { AdCopyModel } from '@models/types'

interface AdCopyReviewItemProps {
  adCopy: Partial<AdCopyModel>,
  title: string,
}

const AdCopyReviewItem = (props: AdCopyReviewItemProps) => {
  const { adCopy: { description, tagline }, title } = props

  return (
    <Box flexDirection="column" paddingY="large">
      <Text fontWeight="500">{title}</Text>

      {stringHasContent(tagline) && (
        <>
          {/*
           // @ts-expect-error TS2741 */}
          <Form.Field label="Tagline" marginTop="large" />

          <Text fontSize="small" lineHeight="1.5" marginTop="small">{tagline}</Text>
        </>
      )}

      {stringHasContent(description) && (
        <>
          {/*
           // @ts-expect-error TS2741 */}
          <Form.Field label="Description" marginTop="large" />

          <Markdown source={description || ''} />
        </>
      )}
    </Box>
  )
}

export default AdCopyReviewItem
